import { money } from "../lib/format";
import { CURRENCIES, commissionOf } from "../lib/transactionForm";

export default function TransactionFields({ form, setField, groups, accounts = [], dateRate, idPrefix = "", allowRecurring = false }) {
  const incomeMode = form.kind === "income";
  const percent = form.commission_mode === "percent";
  const t = id => `${idPrefix}${id}`;
  const options = groups[form.kind] || [];

  const switchKind = kind => {
    setField("kind", kind);
    const list = groups[kind] || [];
    if (!list.includes(form.group)) setField("group", list[0] || "Diğer");
  };

  return (
    <>
      <div className="segmented">
        <button type="button" data-testid={t("income-type-button")} className={incomeMode ? "selected income-btn" : ""} onClick={() => switchKind("income")}>Gelir</button>
        <button type="button" data-testid={t("expense-type-button")} className={!incomeMode ? "selected expense-btn" : ""} onClick={() => switchKind("expense")}>Gider</button>
      </div>
      {incomeMode ? (
        <>
          <div className="form-row">
            <div className="field">
              <label>Ciro <small className="hint">(bilgi amaçlı)</small></label>
              <input data-testid={t("revenue-input")} required type="number" min="0.01" step="0.01" placeholder="Toplam ciro" value={form.gross_revenue} onChange={e => setField("gross_revenue", e.target.value)}/>
            </div>
            <div className="field">
              <div className="field-label-row">
                <label>Komisyon <small className="hint">(gelir)</small></label>
                <div className="mode-toggle" data-testid={t("commission-mode-toggle")}>
                  <button type="button" data-testid={t("commission-mode-percent")} className={percent ? "on" : ""} onClick={() => setField("commission_mode", "percent")}>%</button>
                  <button type="button" data-testid={t("commission-mode-amount")} className={!percent ? "on" : ""} onClick={() => setField("commission_mode", "amount")}>{form.currency === "USD" ? "$" : "₺"}</button>
                </div>
              </div>
              {percent ? (
                <input data-testid={t("commission-rate-input")} required type="number" min="0.01" max="100" step="0.01" placeholder="Oran (%)" value={form.commission_rate} onChange={e => setField("commission_rate", e.target.value)}/>
              ) : (
                <input data-testid={t("commission-input")} required type="number" min="0.01" step="0.01" placeholder="Komisyon tutarı" value={form.commission} onChange={e => setField("commission", e.target.value)}/>
              )}
            </div>
          </div>
          <div className="calculated-income" data-testid={t("calculated-income")}>
            <span className="calc-line">Ciro: <b data-testid={t("calculated-gross")}>{money(Number(form.gross_revenue || 0), form.currency)}</b></span>
            <span className="calc-line">Gelir (komisyon): <strong data-testid={t("calculated-net")}>{money(commissionOf(form), form.currency)}</strong></span>
          </div>
        </>
      ) : (
        <input data-testid={t("amount-input")} required type="number" min="0.01" step="0.01" placeholder="Gider tutarı" value={form.amount} onChange={e => setField("amount", e.target.value)}/>
      )}
      <div className="form-row">
        <input data-testid={t("date-input")} required type="date" value={form.transaction_date} onChange={e => setField("transaction_date", e.target.value)}/>
        <label className="currency-field">
          <small>Para birimi</small>
          <select data-testid={t("currency-select")} value={form.currency} onChange={e => setField("currency", e.target.value)}>
            {CURRENCIES.map(c => <option key={c}>{c}</option>)}
          </select>
        </label>
      </div>
      <div className="date-rate" data-testid={t("date-rate-info")}>
        {dateRate.loading ? "Tarih kuru getiriliyor…" : dateRate.rate ? (
          <>
            Bu tarihte 1 USD = <strong>{dateRate.rate.toFixed(4)} TL</strong>
            {dateRate.rates?.AED && <> · 1 AED = <strong data-testid={t("aed-rate")}>{dateRate.rates.AED.toFixed(4)} TL</strong></>}
            {dateRate.rates?.EUR && <> · 1 EUR = <strong data-testid={t("eur-rate")}>{dateRate.rates.EUR.toFixed(4)} TL</strong></>}
            <small>({dateRate.source})</small>
          </>
        ) : "Kur bulunamadı"}
      </div>
      <div className="form-row">
        <div className="field">
          <label>{incomeMode ? "Gelir kalemi" : "Gider grubu"}</label>
          <select data-testid={t("group-select")} value={form.group} onChange={e => setField("group", e.target.value)}>
            {options.map(g => <option key={g}>{g}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Açıklama</label>
          <input data-testid={t("description-input")} required placeholder="Kısa açıklama" value={form.description} onChange={e => setField("description", e.target.value)}/>
        </div>
      </div>
      {incomeMode && (
        <div className="field">
          <label>Hesap <small className="hint">(hangi otel/cari için)</small></label>
          <select data-testid={t("account-select")} required value={form.account || ""} onChange={e => setField("account", e.target.value)}>
            <option value="">Hesap seçin…</option>
            {accounts.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
      )}
      {allowRecurring && !incomeMode && (
        <label className="recurring-toggle" data-testid={t("recurring-toggle")}>
          <input type="checkbox" data-testid={t("recurring-checkbox")} checked={!!form.recurring} onChange={e => setField("recurring", e.target.checked)}/>
          <span>
            <b>Her ay aynı tutarda tekrar ediyor</b>
            <small>Yeni ay başladığında bu gider ayın {Number(form.transaction_date?.slice(8, 10)) || "aynı"}. günü otomatik eklenir</small>
          </span>
        </label>
      )}
    </>
  );
}
